import { Component } from 'react';

import { Box, Button, Grid } from '@mui/material';
import { inject, observer } from 'mobx-react';
import MaskedInput from 'react-text-mask';
import { flowRight as compose } from 'lodash';

import DriverProfileInformation from '../../components/DriverProfileInformation';
import DriverProfileRoutingTabs from '../../components/DriverProfileRoutingTabs';
import { withRouter } from '../../providers';
import styles from './styles/details';

class DriverDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driver: null,
    };
  }
  componentDidMount() {
    this.loadDriver();
  }

  loadDriver = () => {
    const { driverStore } = this.props;
    const { id } = this.props.match.params;

    driverStore.get(id, (res) => {
      if (res.ok && res.status === 200) {
        this.setState({ driver: res.data });
      }
    });
  };

  searchDriver = (e) => {
    const { store } = this.props;
    store.driverStore.getDrivers();
  };

  setDeleteClose = (value) => {
    this.setState({ isDeleteClose: value });
  };

  back = () => {
    const { store } = this.props;
    store.driverStore.getDrivers();
    this.props.history.goBack();
  };

  render() {
    const { store } = this.props;
    const { driver } = this.state;
    const { userStore } = store;

    return (
      <Box>
        <Box mb={2}>
          <Grid container spacing={1}>
            <Grid>
              <Button
                size='small'
                disableElevation
                variant="outlined"
                onClick={this.back}
                color="inherit"
              >BACK</Button>
            </Grid>
            <Grid flex={1} />
          </Grid>
        </Box>
        <Box sx={styles.driverBox}>
          <DriverProfileInformation driver={driver} />
          <DriverProfileRoutingTabs driver={driver} isShowAction={false} />
        </Box>
      </Box>
    );
  }
}

function TextMaskPhone(props) {
  const { inputRef, masks, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
    />
  );
}

const DriverDetailsCompose = compose(withRouter, inject('driverStore', 'store'), observer)(DriverDetails);

export default DriverDetailsCompose;
